import React from "react";
import { Grid } from "@mui/material";
import VoucherCategoryTable from "./tables/VoucherCategoryTable";

export const VoucherManagement = () => {
    return(
        <>
          
                <Grid
                    container
                    spacing={2}
                >
                  
                    <Grid
                        item
                        xs={12} lg={12}>
                       <VoucherCategoryTable/>

                    </Grid>
                </Grid>
        </>
    )
}